const Theme = {
  logo_image_url: 'nana.png',
  logo_height: 125,

  body_background_color: '#222222',

  button_color: 'black',
  button_radius: 8,

  text_font: `'Open Sans', sans-serif`,
  text_color: 'black',
  title_font: `'Open Sans', sans-serif`,

  photobooth_button_color: 'white',
  photobooth_button_text_color: 'black',
}

export default Theme
